import {AttachmentFile} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {Dialog, DialogContent} from '@mui/material'
import React, {useState} from 'react'

import {StepSalesForecastDropzone, StepSalesForecastPreview} from './uploadSteps'

type UploadStep = 'dropzone' | 'preview'

interface UploadSalesForecastDialogProps {
  isOpen: boolean
  closeDialog: () => void
}

export const UploadSalesForecastDialog: React.FC<UploadSalesForecastDialogProps> = ({
  isOpen,
  closeDialog
}) => {
  const [files, setFiles] = useState<AttachmentFile[]>([])
  const [step, setStep] = useState<UploadStep>('dropzone')

  const handleCancelUpload = () => {
    closeDialog()
    setFiles([])
    setStep('dropzone')
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return
      }}
      maxWidth={false}
      {...dataTestId('upload_sales_forecast_dialog')}
    >
      {isOpen && (
        <DialogContent sx={{p: 3, minWidth: ({spacing}) => spacing(56)}}>
          {step === 'dropzone' && (
            <StepSalesForecastDropzone
              files={files}
              setFiles={setFiles}
              nextStep={() => setStep('preview')}
              cancelUpload={handleCancelUpload}
            />
          )}
          {step === 'preview' && (
            <StepSalesForecastPreview
              files={files}
              cancelUpload={handleCancelUpload}
              onUploadComplete={handleCancelUpload}
            />
          )}
        </DialogContent>
      )}
    </Dialog>
  )
}
